<template>
<div id="video_slideshow_preview">
  <!-- *** Get channel, insert that in the data-channel attribute *** -->
  <div id="main-container" data-channel="media-gallery-video-wall">

    
    <!-- *** Insert recid for this instance in the data-instance attribute *** -->
		<div id="scenes-container">
			
			<!-- *** For each scene, insert data attributes for the scene and zones *** -->
			<!-- Scene 01 -->
			<div class="scene-wrapper" data-scene="scene-01" v-if="slideIndex == 1">
				<div class="block-opacity" :style="zone6.style" data-zone="zone-06"></div>
				<div class="block-solid"  :style="zone7.style" data-zone="zone-07"></div>

					<div class="content-container">

						<div class="text-container">
              <div class="text-wrapper" :style="zone1.style">
                <div class="title" data-zone="zone-02">
                  <div class="title-text text-right">{{zone2.val}}</div>
                </div>

                <div class="description" data-zone="zone-03">
                  <span class="description-text text-right">{{zone3.val}}</span>
                </div>

                <div class="credits" data-zone="zone-04">
                  <span class="credits-text text-right">{{zone4.val}}</span>
                </div>
              </div>
						</div>

						<div class="img-container" data-zone="zone-05">
              <div class="img-wrapper">
							  <img :style="getImageStyle(zone5)" :src="this.GALLERY_HOST + '/' + zone5.val">
              </div>
						</div>

					</div> <!-- END content-container -->

			</div> <!-- END scene-wrapper scene-one -->
			
			
			<!-- Scene 02 -->
			<div class="scene-wrapper" data-scene="scene-02" v-if="slideIndex == 2"> 
				<div class="block-opacity" :style="zone11.style" data-zone="zone-11"></div>
				<div class="block-solid" :style="zone12.style" data-zone="zone-12"></div>

            <div class="content-container">

						<div class="text-container">
              <div class="text-wrapper" :style="zone1.style">
                <div class="title" data-zone="zone-02">
                  <div class="title-text">{{zone2.val}}</div>
                </div>

                <div class="description" data-zone="zone-09">
                  <span class="description-text">{{zone9.val}}</span>
                </div>

                <div class="credits" data-zone="zone-10">
                  <span class="credits-text">{{zone10.val}}</span>
                </div>
              </div>
						</div>

						<div class="img-container" data-zone="zone-08">
              <div class="img-wrapper">
							  <img :style="imagePos(zone8)" :src="this.GALLERY_HOST + '/' + zone8.val">
              </div>
						</div>

					</div> <!-- END content-container -->

			</div> <!-- END scene-wrapper scene-two -->

			
			<!-- Scene 03 -->
			<div class="scene-wrapper" data-scene="scene-03" v-if="slideIndex == 3">
				<div class="block-opacity" :style="zone16.style" data-zone="zone-16"></div>
				<div class="block-solid" :style="zone17.style" data-zone="zone-17"></div>

					<div class="content-container">

						<div class="text-container">
              <div class="text-wrapper" :style="zone1.style">
                <div class="title" data-zone="zone-02">
                  <div class="title-text">{{zone2.val}}</div>
                </div>

                <div class="description" data-zone="zone-13">
                  <span class="description-text">{{zone13.val}}</span>
                </div>

                <div class="credits" data-zone="zone-14">
                  <span class="credits-text">{{zone14.val}}</span>
                </div>
              </div>
						</div>

						<div class="img-container" data-zone="zone-15">
              <div class="img-wrapper">
							  <img :style="imagePos(zone15)" :src="this.GALLERY_HOST + '/' + zone15.val">
              </div>
						</div>

					</div> <!-- END content-container -->

			</div> <!-- END scene-wrapper scene-three -->

			<!-- Scene 04 -->
			<div class="scene-wrapper" data-scene="scene-04" v-if="slideIndex == 4">
				<div class="block-opacity" :style="zone21.style" data-zone="zone-21"></div>
				<div class="block-solid" :style="zone22.style" data-zone="zone-22"></div>

					<div class="content-container">

						<div class="text-container">
              <div class="text-wrapper" :style="zone1.style">
                <div class="title" data-zone="zone-02">
                  <div class="title-text">{{zone2.val}}</div>
                </div>

                <div class="description" data-zone="zone-18">
                  <span class="description-text">{{zone18.val}}</span>
                </div>

                <div class="credits" data-zone="zone-19">
                  <span class="credits-text">{{zone19.val}}</span>
                </div>
              </div>
            </div>

						<div class="img-container" data-zone="zone-20">
              <div class="img-wrapper">
                <img :style="imagePos(zone20)" :src="this.GALLERY_HOST + '/' + zone20.val">
              </div>
						</div>

					</div> <!-- END content-container -->

			</div> <!-- END scene-wrapper scene-four -->

			<!-- Scene 05 -->
			<div class="scene-wrapper" data-scene="scene-05" v-if="slideIndex == 5">
				<div class="block-opacity" :style="zone23.style" data-zone="zone-23"></div>
				<div class="block-solid" :style="zone27.style" data-zone="zone-27"></div>

					<div class="content-container">

						<div class="text-container">
              <div class="text-wrapper" :style="zone1.style">
                <div class="title" data-zone="zone-02">
                  <div class="title-text">{{zone2.val}}</div>
                </div>

                <div class="description" data-zone="zone-25">
                  <span class="description-text">{{zone25.val}}</span>
                </div>

                <div class="credits" data-zone="zone-26">
                  <span class="credits-text">{{zone26.val}}</span>
                </div>
              </div>
            </div>

						<div class="img-container" data-zone="zone-24">
              <div class="img-wrapper">
                <img :style="imagePos(zone24)" :src="this.GALLERY_HOST + '/' + zone24.val">
              </div>
						</div>

					</div> <!-- END content-container -->

			</div> <!-- END scene-wrapper scene-five -->

			
			<div class="scene-wrapper" id="branding-container" v-if="slideIndex == 6">
        <div class="logo-wrapper">
					<img src="assets/schomburg-logo-white.svg">
        </div>
			</div>

		</div> <!-- END scenes-container -->
    
	</div> <!-- END main-container -->
</div>
</template>

<script>
import BasePreview from './../BasePreview';

export default {
   extends: BasePreview,

   data() {
      return {
         slideIndex: 0,

         zone1: {},
         zone2: {},
         zone3: {},
         zone4: {},
         zone5: {},
         zone6: {},
         zone7: {},
         zone8: {},
         zone9: {},
         zone10: {},
         zone11: {},
         zone12: {},
         zone13: {},
         zone14: {},
         zone15: {},
         zone16: {},
         zone17: {},
         zone18: {},
         zone19: {},
         zone20: {},
         zone21: {},
         zone22: {},
         zone23: {},
         zone24: {},
         zone25: {},
         zone26: {},
         zone27: {},
      }
   },

   created() {
      this.assignZones();
      this.slideIndex = 0;
      this.carousel();
   },

   methods: {
      carousel() {
         this.slideIndex++;
         setTimeout(this.carousel, 24000); // Change scene every this number of milliseconds
      },

      assignZones() {
         this.zone1   = this.getAsset('media', 1000);
         this.zone2   = this.getAsset('text', 2000);
         this.zone3   = this.getAsset('text', 3000);
         this.zone4   = this.getAsset('text', 4000);
         this.zone5   = this.getAsset('media', 5000);
         this.zone6   = this.getAsset('media', 6000);
         this.zone7   = this.getAsset('media', 7000);
         this.zone8   = this.getAsset('media', 8000);
         this.zone9   = this.getAsset('text', 9000);
         this.zone10  = this.getAsset('text', 10000);
         this.zone11  = this.getAsset('media', 11000);
         this.zone12  = this.getAsset('media', 12000);
         this.zone13  = this.getAsset('text', 13000);
         this.zone14  = this.getAsset('text', 14000);
         this.zone15  = this.getAsset('media', 15000);
         this.zone16  = this.getAsset('media', 16000);
         this.zone17  = this.getAsset('media', 17000);
         this.zone18  = this.getAsset('text', 18000);
         this.zone19  = this.getAsset('text', 19000);
         this.zone20  = this.getAsset('media', 20000);
         this.zone21  = this.getAsset('media', 21000);
         this.zone22  = this.getAsset('media', 22000);
         this.zone23  = this.getAsset('media', 23000);
         this.zone24  = this.getAsset('media', 24000);
         this.zone25  = this.getAsset('text', 25000);
         this.zone26  = this.getAsset('text', 26000);
         this.zone27  = this.getAsset('media', 27000);
      },
   }
}
</script>

<style lang="scss" scoped>
// dimensions of the video wall is 4800x1200
$width: 4800px;
$height: 1200px;

$body-bg: #000;

// These background colors need to come BARD, putting them here for now
$text-bg: #fff; // zone-01 

$block-color-one: #3f6275; //zone-06 blue
$block-color-two: #f99e1c; //zone-06 mustard
$block-color-three: #4c4184; //zone-06 purple
$block-color-four: #c4622d; //zone-06 rust
$block-color-five: #c19a6b; //zone-06 brown

// $branding-color: pink; // branding logo pink
$branding-bg: gray; 
$branding-gradient: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%);

* {
  margin: 0;
  padding: 0;
  border: 0;
	box-sizing: border-box;
  pointer-events: none;
  touch-action: none;
}

*:focus {
  outline: none;
}

.text-right {
   text-align: right;
}

#video_slideshow_preview {
   width: $width;
   height: $height;
   background: $body-bg;
   color: #000;
   line-height: 1.5;

   font-family: Roboto, Arial, sans-serif;
   font-size: 16px;
   transform: scale(.3);
   transform-origin: top left;
   position: absolute;
   top: 200px;
}

#main-container {
  position: relative;
  width: 4608px;
  // width: 96%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
  transform-style: preserve-3d;
  z-index: 1;
  opacity: .65;
}


// Solid color block behind the content = zone-06
.block-solid {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: #000;
	outline: 1px solid transparent;
	backface-visibility: hidden;
  z-index: 0;
}

// Opacity block to the left of the content = zone-07
.block-opacity {
	position: absolute;
  left: 10%;
  top: 0;
  width: 30%;
  height: 100%;
  background-color: rgba(#000, .25);
	backface-visibility: hidden;
  z-index: 0;
}

#scenes-container {
	position: relative;
	width: 100%;
	height: 100%;
  transform-style: preserve-3d;
  

  // 	Default Scene corresponds to each data-scene
	.scene-wrapper {
    position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    animation: fade 24s linear forwards;
		z-index: 1;

    // content-container is 90% width of the #main-container or 4147px, leaving 230.5px on left and right 
		.content-container {
      position: absolute;
			left: 0;
			top: 0;
      width: 4147px;
			height: 100%;
			display: flex;
      justify-content: flex-start;
			align-content: flex-start;
      backface-visibility: hidden;
      transform-style: preserve-3d;

      // 960px is the width of each screen
			.text-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 1612px;
        height: 100%;

        // Just a little smaller than 960 so we don't cut off text 
        .text-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          padding: 6rem;
          overflow: hidden;
          text-align: left;
          transform-style: preserve-3d;
          backface-visibility: hidden;

          .title {
            margin-bottom: 1.5rem;
            .title-text {
              text-transform: uppercase;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: pre-wrap; 
              word-wrap: break-word;
              font-size: 5.5rem;
              line-height: 1.15;
            }
          }

          .description {
            position: relative;
            top: 16px;
            margin-bottom: 1rem;
            span {
              position: absolute;
              min-width: 0;
              display: -webkit-box;
              -webkit-line-clamp: 8;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: pre-wrap; 
              word-wrap: break-word;
              font-size: 3rem;
              line-height: 1.25;
            }
          }

          .credits {
             
            position: absolute;
            bottom: 5rem;
            margin: 0 6rem;
            .credits-text {
              display: -webkit-box;
              -webkit-line-clamp: 6;
              -webkit-box-orient: vertical;
              overflow: hidden;
              white-space: pre-wrap; 
              word-wrap: break-word;
            //   font-size: 1.85rem;
               font-size: 36px;
              line-height: 1.5;
            }
          }
        }
			}

			.img-container {
        width: 1972px;
        position: absolute;
        top: 0;
        bottom: 0;
        flex: 0 0 2995px;
        height: 100%;
        text-align: center;
        transform-style: preserve-3d;
        .img-wrapper {
          width: 100%;
          height: 100%;
          overflow: hidden;
          backface-visibility: hidden;
          img {
            position: absolute;
            filter: drop-shadow(10px 10px 19px #000000);
            -webkit-filter: drop-shadow(10px 10px 19px #000000);
            max-width: unset;
          }
        }
			}
		}

    // Scene One
    &[data-scene="scene-01"] {
      .block-opacity {
        background-color: rgba($block-color-one, .25);
        animation: slideDown 8.85s ease-out forwards, slideUpOut 3.5s ease-in forwards;
        animation-delay: 0s, 20.75s;
      }
      .block-solid {
        left: 5%;
        background-color: $block-color-one;
        animation: revealRTL 9s linear forwards, slideUpOut 6s forwards;
        animation-delay: 0s, 20.95s;
      }
      .content-container {
        animation: revealRTL 9s linear forwards;
        .text-container {
          left: 520px;
          animation: revealRTLlonger 10s ease-out both, slideUpOut 5.25s ease both;

          animation-delay: .65s, 21s;
          .text-wrapper {
            text-align: right;
          }
          .description span, .credits {
            right: 0;
          }
        }
        .img-container {
          left: 2200px;
          right: 0;
          .img-wrapper {
            animation: revealRTL 4s ease-out both, slideUpOut 6s ease forwards;
            animation-delay: 0s, 20.75s;
          }
        }
      }
    }

    // Scenes Two
    &[data-scene="scene-02"] {
      .block-opacity {
        background-color: rgba($block-color-two, .25);
        animation: slideUp 8.85s ease-out forwards, slideUpOut 4s ease-in forwards;
        animation-delay: 0s, 14.95s;
      }
      .block-solid {
        background-color: $block-color-two;
        animation: slideRTL 19s ease-in forwards;
        animation-delay: 0s;
      }
      .content-container {
        animation: slideRTL 18.95s linear both;
        animation-delay: .15s;
        .text-container {
          left: 2445px;
          order: 2;
          .text-wrapper {
            animation: slideRTL 18.85s ease-in both;
          }
          .description span, .credits {
          left: 0;
        }
        }
        .img-container {
          left: 0;
          right: 1460px;
          order: 1;
          .img-wrapper {
            animation: slideRTL 18.8s ease-in both;
          }
        }
      }
    }

    // Scene Three
    &[data-scene="scene-03"] {
      .block-opacity {
        animation: slideLTR 24s both;
        animation-delay: 0s;
        background-color: rgba($block-color-three, .25);
      }
      .block-solid {
        left: 5%;
        animation: slideLTR 23.85s both;
        animation-delay: .15s;
        background-color: $block-color-three;
      }
      .content-container {
        animation: slideLTR 24s ease-out both;
        animation-delay: .25s;
        .text-container {
          left: 510px;
          animation: slideLTR 24s ease-in-out both;
          .text-wrapper {
            text-align: right;
          }
        }
        .description span, .credits {
          right: 0;
        }
        .img-container {
          left: 2700px;
          right: 0;
          .img-wrapper {
            animation: slideLTR 23s ease-in-out both;
            animation-delay: 3s;
          }
        }
      }
    }

    // Scene Four
    &[data-scene="scene-04"]  {
      .block-opacity {
        left: 60%;
        background-color: rgba($block-color-four, .25);
        animation: slideDown 8.85s ease-out forwards, slideUpOut 3.5s ease-in forwards;
        animation-delay: 0s, 15.75s;
      }
      .block-solid {
        background-color: $block-color-four;
        animation: revealLTR 9s ease-out both, slideUpOut 6s forwards;
        animation-delay: 0s, 19.95s
      }
      .content-container {
        animation: revealRTL 9s linear forwards;
        .text-container {
          left: 2445px;
          animation: revealRTL 9s ease-out both, slideUpOut 5s ease forwards;
          animation-delay: .25s, 20s;
          .description span, .credits {
            left: 0;
          }
        }

        .img-container {
          left: 0;
          right: 1860px;
          .img-wrapper {
            text-align: right;
            animation: revealRTL 2s ease-out both, slideUpOut 6s ease none;
            animation-delay: 0s, 18.85s;
          }
        }
      }
    }

    // Scene Five
    &[data-scene="scene-05"] {
      .block-opacity {
        left: 60%;
        background-color: rgba($block-color-five, .25);
        animation: slideDown 8.85s ease-out forwards, slideUpOut 3.5s ease-in forwards;
        animation-delay: 0s, 16.75s;
      }
      .block-solid {
        background-color: $block-color-five;
        animation: slideLTR 22s ease-out forwards;
      }
      .content-container {
        animation: slideRTL 23.5s linear both;
        .text-container {
          left: 2445px;
          animation: slideRTL 23.5s ease-in both;
          animation-delay: .15s;
          .description span, .credits {
            left: 0;
          }
        }

        .img-container {
          left: 0;
          right: 1860px;
          .img-wrapper {
            animation: slideRTL 22s ease-in both;
          }
        }
      }
    }

    // Branding 
    &#branding-container {
      display: flex;
      justify-content: center;
      align-items: center; 
      background-color: $branding-bg;
      background-image: $branding-gradient;
      animation: fadeInOut 23.85s linear;
      .logo-wrapper {
        flex: 0 0 50%;
        height: 100%;
        margin: 0 auto;
        text-align: center;
        z-index: 1;
        img {
          width: 100%;
          height: 100%;
          opacity: 0;
          animation: logo 20s ease-in-out both;
          animation-delay: .25s;
        }
      }
    }
  }
}

// Animations
@keyframes fade {
	0% {
		opacity: 0;
	}
  1%, 99% {
    opacity: 1;
  }
	100% {
		opacity: 0
	}
}

@keyframes fadeOut {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0
	}
}

@keyframes slideDown {
  0% {
     opacity: 0;
     transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideUp {
  0% {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideUpOut {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -200%, 0);
  }
}

@keyframes slideRTL {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  2% {
		opacity: .75;
	}
	46%, 79% {
    opacity: 1;
    transform: translate3d(0, 0, 0)
	}
  100% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes slideLTR {
	0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  2% {
		opacity: .75;
	}
	46%, 79%  {
    opacity: 1;
    transform: translate3d(0, 0, 0);
	}
  100% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes revealRTL {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
	2% {
		opacity: .75;
	}
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes revealRTLlonger {
  0% {
    opacity: 0;
    transform: translate3d(200%, 0, 0);
  }
	2% {
		opacity: .75;
	}
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes revealLTR {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
	2% {
		opacity: .75;
	}
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

// Branding logo animation
@keyframes logo {
  0% {
    opacity: 0;
    transform: translate3d(0, 200%, 0);
  }
	40%, 100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

</style>